import { FullScreenLayout } from 'ui/fullScreen/FullScreenLayout';

import { PreviewPane } from './preview/PreviewPane';
import { DataPane } from '../common/PreviewWithDataDataPane';
import { SettingsDrawer } from '../common/SettingsDrawer';
import {
  EditorContentContainer,
  LayoutContentContainerFullWidth,
  PreviewWithErrorContainer,
} from '../common';
import { ViewFooter } from '../common/ViewFooter';
import { ViewHeader } from '../common/ViewHeader';
import { useTemplateQueryContext } from '../context/TemplateQueryContext';
import { usePushPreviewContext } from './context/PushPreviewContext';
import { PreviewContentContainer } from '../common/PreviewContentContainer';
import { PreviewWithDataError } from '../common/PreviewWithDataError';

export const TEMPLATE_EDITOR_PUSH_PREVIEW_W_DATA = 'template-editor-push-preview-w-data';

export const PreviewWithDataCore = () => {
  const { onRefreshPreview, previewError } = usePushPreviewContext();
  return (
    <EditorContentContainer data-test={TEMPLATE_EDITOR_PUSH_PREVIEW_W_DATA}>
      <DataPane onRefreshPreview={onRefreshPreview} />
      <PreviewWithErrorContainer>
        {previewError && <PreviewWithDataError previewError={previewError} />}
        <PreviewPane />
      </PreviewWithErrorContainer>
    </EditorContentContainer>
  );
};

export const PreviewWithData = () => {
  const { onRefreshPreview } = usePushPreviewContext();
  const { refetch } = useTemplateQueryContext();

  return (
    <FullScreenLayout
      actionBarIsAnchored
      DrawerContent={
        <SettingsDrawer
          onSaveSuccess={() => {
            onRefreshPreview();
            refetch();
          }}
        />
      }
      HeaderContent={<ViewHeader />}
      FooterContent={<ViewFooter />}
    >
      <PreviewContentContainer data-test="template-editor-push-preview">
        <LayoutContentContainerFullWidth>
          <PreviewWithDataCore />
        </LayoutContentContainerFullWidth>
      </PreviewContentContainer>
    </FullScreenLayout>
  );
};

export default PreviewWithData;
